
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_429_279)","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M6 9.498a.656.656 0 100-1.312.656.656 0 000 1.312z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.998 6.875v-.438c.966 0 1.75-.685 1.75-1.53 0-.846-.784-1.532-1.75-1.532s-1.75.686-1.75 1.531v.219M11.25 6A5.25 5.25 0 11.75 6a5.25 5.25 0 0110.5 0z","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_429_279"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    